import React from "react";
import { CheckIcon, ShieldCheckIcon } from "lucide-react";
import { SectionCta } from "../SectionCta";
import { guaranteeItems } from "../../data/offer";
export function GuaranteeSection() {
  return <section className="w-full bg-white px-5 py-16 sm:py-24" data-id="element-192" data-mp="1kb2gy3fa9p8g">
      <div className="mx-auto max-w-4xl" data-id="element-193" data-mp="1k9j4knwqzyby">
        <div className="grid items-center gap-8 md:grid-cols-[auto_1fr]" data-id="element-194" data-mp="1fbpxlsnmf0am">
          <div className="mx-auto flex h-40 w-40 flex-col items-center justify-center rounded-full border-[6px] border-gold bg-navy-900 text-center sm:h-48 sm:w-48" data-id="element-195" data-mp="1adfxr4qybbio">
            <ShieldCheckIcon className="h-10 w-10 text-gold" aria-hidden="true" data-id="element-196" data-mp="15gpmqvu07644" />
            <span className="mt-1 text-4xl font-black leading-none text-white" data-id="element-197" data-mp="11djfbkv5n8w2">7</span>
            <span className="text-xs font-extrabold uppercase tracking-widest text-gold" data-id="element-198" data-mp="wf869ccop2ew">Day Guarantee</span>
          </div>
          <div className="text-center md:text-left" data-id="element-199" data-mp="2voy8ycradsh3">
            <p className="text-xs font-extrabold uppercase tracking-[0.16em] text-brand sm:text-sm" data-id="element-200" data-mp="2qroc4c1kiej8">Your Purchase Protection</p>
            <h2 className="mt-3 text-[28px] font-black leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-201" data-mp="1g3abl7ta2lmq">
              Explore the System With Confidence
            </h2>
            <p className="mt-4 text-base leading-relaxed text-ink-muted sm:text-lg" data-id="element-202" data-mp="1756zt383h384">
              I want you to feel comfortable reviewing the material and deciding whether it meets your professional learning
              needs.
            </p>
          </div>
        </div>

        <div className="mt-10 rounded-3xl bg-surface p-5 sm:p-8" data-id="element-203" data-mp="23u68ukgi691d">
          <p className="text-[15px] font-semibold text-ink" data-id="element-204" data-mp="23wimilf89x8m">
            With SELF-LIGATING ORTHODONTICS BLUEPRINT™, you'll be able to explore:
          </p>
          <ul className="mt-4 grid gap-2.5 sm:grid-cols-2" data-id="element-205" data-mp="1v12ortbcqxxr">
            {guaranteeItems.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] text-ink" data-id="element-206" data-mp="2iqwzo5c42cfd">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-207" data-mp="2njgnrw8fcpyf" />
                {item}
              </li>)}
          </ul>
          <div className="mt-6 border-t border-navy-900/10 pt-5" data-id="element-208" data-mp="2serhx9o1n93r">
            <p className="text-lg font-black text-ink" data-id="element-209" data-mp="2sdgcz6iv3vb2">7-Day Satisfaction Guarantee</p>
            <p className="mt-2 text-[15px] leading-relaxed text-ink-muted" data-id="element-210" data-mp="2nias8b174mok">
              You can request a refund within seven days of purchase if the material doesn't meet your expectations, under the
              refund policy published at checkout.
            </p>
          </div>
        </div>

        <SectionCta label="Get Instant Access" data-id="element-211" data-mp="29mq9bflgw4h5" />
      </div>
    </section>;
}